import { render } from "./8.vue?vue&type=template&id=3a1f54c0"
const script = {}

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__